<template>
  <div>
    <loading v-if="getLoading" />
    <MobileSelectPopUp
      v-show="showMobilePop"
      @mobileValueChange="mobileValueChange"
    />
    <TermsPopUp
      ref="terms"
      :class="termsFlag"
      @termsToggleChange="termsToggleChange"
    />
    <AppModal
      v-if="modalToggle"
      :message="message"
      :btnCase="btnCase"
      @modalConfirm="modalConfirm"
    />
    <div class="app-wrap">
      <AppSignUpHeader
        :headerText="headerText"
        :termsToggle="termsToggle"
        @termsToggleChange="termsToggleChange"
        @closeComponentEmit="closeComponentEmit"
        :headerBtn="true"
      />
      <ProgressBar v-if="visible">
        <template #text>본인인증</template>
        <template #step2>
          <div class="progress-on"></div>
        </template>
      </ProgressBar>
      <div class="auth-wrap">
        <div class="title">
          <p>이름</p>
          <input
            type="text"
            placeholder="이름"
            class="name"
            v-model="name"
            :disabled="!beforeAuth"
          />
        </div>
        <div class="title">
          <p>국적 선택</p>
          <div class="nationality">
            <label for="nationality1">
              <input
                type="radio"
                id="nationality1"
                name="nationality"
                v-model="registerType"
                value="1"
                :disabled="!beforeAuth"
              />
              <span>내국인</span>
            </label>
            <label for="nationality2">
              <input
                type="radio"
                id="nationality2"
                name="nationality"
                v-model="registerType"
                value="2"
                :disabled="!beforeAuth"
              />
              <span>외국인</span>
            </label>
          </div>
        </div>
        <div class="title">
          <p>생년월일 / 성별</p>
          <div class="birth">
            <input
              type="text"
              placeholder="생년월일 6자리"
              class="birth-six"
              maxlength="6"
              pattern="\d*"
              inputmode="numeric"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              v-model="birthday"
              :disabled="!beforeAuth"
            />
            <span class="birth-hypen">-</span>
            <div class="birth-one">
              <input
                type="text"
                maxlength="1"
                pattern="\d*"
                inputmode="numeric"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                v-model="gender"
                :disabled="!beforeAuth"
              />
              <div class="birth-circle">
                <span v-for="item in 6" :key="item"></span>
              </div>
            </div>
          </div>
        </div>
        <!-- skt : 1, kt: 2, lg: 3,  -->
        <!-- 알뜰폰 skt: 5, kt: 6, lg: 7 -->
        <div class="title">
          <p>휴대폰번호</p>
          <div class="mobile">
            <div class="mobile-num">
              <label for="mobile1">
                <input
                  type="radio"
                  id="mobile1"
                  name="mobile"
                  v-model="mobileCo"
                  value="1"
                  :disabled="!beforeAuth"
                />
                <span>SKT</span>
              </label>
              <label for="mobile2">
                <input
                  type="radio"
                  id="mobile2"
                  name="mobile"
                  v-model="mobileCo"
                  value="2"
                  :disabled="!beforeAuth"
                />
                <span>KT</span>
              </label>
              <label for="mobile3">
                <input
                  type="radio"
                  id="mobile3"
                  name="mobile"
                  v-model="mobileCo"
                  value="3"
                  :disabled="!beforeAuth"
                />
                <span>LG U+</span>
              </label>
              <label for="mobile5" @click="openMobilePop" v-if="mobileCo == 5">
                <input
                  type="radio"
                  id="mobile5"
                  name="mobile"
                  v-model="mobileCo"
                  value="5"
                  :disabled="!beforeAuth"
                />
                <span>SKT<br />알뜰폰</span>
              </label>
              <label
                for="mobile6"
                @click="openMobilePop"
                v-else-if="mobileCo == 6"
              >
                <input
                  type="radio"
                  id="mobile6"
                  name="mobile"
                  v-model="mobileCo"
                  value="6"
                  :disabled="!beforeAuth"
                />
                <span>KT<br />알뜰폰</span>
              </label>
              <label
                for="mobile7"
                @click="openMobilePop"
                v-else-if="mobileCo == 7"
              >
                <input
                  type="radio"
                  id="mobile7"
                  name="mobile"
                  v-model="mobileCo"
                  value="7"
                  :disabled="!beforeAuth"
                />
                <span>LG U+<br />알뜰폰</span>
              </label>
              <label for="mobile4" @click="openMobilePop" v-else>
                <input
                  type="radio"
                  id="mobile4"
                  name="mobile"
                  :disabled="!beforeAuth"
                />
                <span>알뜰폰</span>
              </label>
            </div>
            <input
              type="text"
              placeholder="휴대폰번호(-제외)"
              class="input-mobile"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              maxlength="11"
              pattern="\d*"
              inputmode="numeric"
              v-model="mobileNo"
              :disabled="!beforeAuth"
              enterkeyhint="done"
              @keyup.enter="hideKeyboard"
            />
          </div>
        </div>
        <div class="title" v-if="!beforeAuth">
          <p>인증번호</p>
          <div class="timer-box" v-if="reqFlag">
            <input
              type="text"
              placeholder="인증번호입력"
              class="input-mobile"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              maxlength="6"
              pattern="\d*"
              inputmode="numeric"
              v-model="authValue"
              @focus="handleFocus"
              @blur="handleBlur"
            />
            <span class="timer" enterkeyhint="done" @keyup.enter="hideKeyboard">
              <Timer
                ref="timer"
                @startTimer="startTimer"
                @emitStopTimer="emitStopTimer"
              />
            </span>
          </div>
          <div class="req-btn" v-else>
            <input
              type="text"
              placeholder="인증번호"
              class="input-mobile"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              maxlength="6"
              pattern="\d*"
              inputmode="numeric"
              v-model="authValue"
              enterkeyhint="done"
              @keyup.enter="hideKeyboard"
            />
            <button @click="authFirst">재요청</button>
          </div>
        </div>
      </div>
      <div class="auth-agree-wrap" v-show="beforeAuth">
        <div class="title">약관동의</div>
        <div class="agree-group">
          <div class="all-title">
            <label for="agreeAuthAgree">
              <input
                type="checkbox"
                id="agreeAuthAgree"
                v-model="allCheck"
                @click="selectCheckAll"
                :disabled="!beforeAuth"
              />
              <span></span>
              <span>전체 약관에 동의합니다</span>
            </label>
          </div>
          <ul class="agree-list">
            <li v-for="(term) in agreeList" :key="term.name">
              <label :for="term.name">
                <input type="checkbox" :id="term.name" v-model="term.isApprove" :disabled="!beforeAuth" @change="setAllCheck">
                <span></span>
                <span class="txt">
                  <span>{{ essentialFlag(term) }} {{ term.name }}</span>
                </span>
              </label>
              <span @click="termsDetailOpenHardCode(term)" :data-agree="term.name">보기</span>
            </li>
          </ul>
        </div>
      </div>
      <button
        class="full-auth-btn"
        @click="authFirst"
        v-if="beforeAuth"
        :disabled="nextValidator"
      >
        인증번호 요청
      </button>
      <button
        class="full-auth-btn"
        v-else
        :disabled="authValue.length != 6"
        @click="authSecond"
      >
        인증 확인
      </button>
    </div>
    <SafeDoubleBtnDialog 
      v-if="localShowDoubleBtnDialogFlag && doubleBtnMsgType"
      :message="doubleBtnMsgType"
      @retryOldAuth="onClickRetryOldAuth" 
      @useNewAuth="onClickUseNewAuth"
    />
    <components
      v-if="currentComponent != null"
      :is="currentComponent"
      :visible="visible"
      :isRegister="isRegister"
      :shareData="shareData"
      :authType="authType"
      :osCheck="osCheck"
      @nextComponent="nextComponent"
      @closeComponentEmit="closeComponentToggle"
      @appClose="appClose"
      class="pop-top"
    />

  </div>
</template>

<script lang="js">
import service from '@/backend/modnpay_app_api'
import { THROW_APP_ERROR, THROW_APP_LOGIN_OVER_LAP } from '@/router'
import AppSignUpHeader from '@/components/Header/AppSignUpHeader.vue'
import ProgressBar from '@/components/SignUp/ProgressBar.vue'
import MobileSelectPopUp from '@/components/SignUp/MobileSelectPopUp.vue'
import Timer from '@/components/SignUp/Timer.vue'
import TermsPopUp from '@/components/Terms/TermsPopUp.vue'
import loading from '@/components/Common/Loading.vue'
import { scrollSet } from '@/utils/Methods'
import SafeDoubleBtnDialog from '@/components/Dialog/SafeDoubleBtnDialog.vue'
import { MESSAGE_DOUBLE_BUTTON } from '@/utils/Message'
import TermsMixins from '@/utils/TermsMixins'
import CommunicationTermMixins from '@/utils/CommunicationTermMixins'
import { SET_TEMP_USER_CODE } from '@/store/_actions/actionTypes'

import AppSignUpAgreePage from '@/views/AppSignUpAgreePage.vue'
/* eslint-disable eqeqeq */
export default {
  components: {
    AppSignUpHeader,
    ProgressBar,
    MobileSelectPopUp,
    Timer,
    TermsPopUp,
    loading,
    SafeDoubleBtnDialog,
    AppSignUpAgreePage
  },
  props: {
    visible: Boolean,
    authType: Number,
  },
  mixins: [TermsMixins, CommunicationTermMixins],
  data () {
  return {
      authValue: '',
      authTxId: '',
      ci: '',
      reqFlag: true,
      localShowDoubleBtnDialogFlag: false,
      currentComponent: null,

      //약관동의
      osCheck: false,
      isRegister: true,
      shareData: {}
    }
  },
  created () {
    this.headerTextSwitch();
  },   
  computed: {
    getLoading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    headerTextSwitch () {
      if (this.visible) {
        this.headerText = '시작하기'
      } else {
        this.headerText = '본인인증'
      }
    },
    startTimer () { // 타이머 시작
      this.$refs.timer.startTimer()
    },
    emitStopTimer () { // 3분 경과시 재요청 플래그
      this.reqFlag = false
    },
    async authFirst () { // 본인인증 1차
      if (!this.checkDomestic()) return
      const req = {
        jumin: this.birthday + this.gender,
        name: this.name,
        mobileCo: this.mobileCo,
        mobileNo: this.mobileNo,
        authType: this.authType // 0: 비밀번호 찾기 1: 회원가입 2 재설치 본인인증, 3: 성인인증
      }
      const { data } = await service.authFirst(req)
      const code = data.resultCode
      if (code == 0) {
        this.beforeAuth = false
        this.reqFlag = true
        this.authTxId = data.authTxId
        this.$nextTick(() => {
          this.startTimer()
        })
      } else if (code == 11221) {
        this.message = '아쉽게도 14세미만은 회원가입이 어렵습니다.<br/>다시 확인해주세요.'
        this.modalToggleChange()
        this.name = '' // 이름
        this.birthday = '' // 생년월일
        this.gender = '' // 뒷자리
        this.mobileNo = '' // 휴대폰 번호
        this.mobileCo = '1' // 통신사
        this.authValue = '' // 인증번호
      } else {
        this.isInvalidInfomation()
      }
    },
    async authSecond () { // 본인인증 2차
      const req = {
        jumin: this.birthday + this.gender,
        deviceId: localStorage.getItem('deviceId'),
        authTxId: this.authTxId,
        authValue: this.authValue,
        authType: this.authType // 0: 비밀번호 찾기 1: 회원가입 2 재설치 본인인증, 3: 성인인증
      }
      const { data } = await service.authSecond(req)
      this.$store.commit(SET_TEMP_USER_CODE, data.userCode)
      const code = data.resultCode
      this.ci = data.ci
      
      // else if (code == 0 && data.member && this.visible) {
      //   localStorage.setItem('appUserCode', data.userCode)
      //   this.appUpdateUserInfo(data.userCode)
      //   this.message = '이미 가입된 회원입니다'
      //   this.modalToggleChange()
      //   this.modalCase = 2
      // }
      localStorage.removeItem('Authorization')
      if (code == 0 && !data.member && !this.visible) {
        // 비밀번호 찾기에서 회원 아닐때
        this.message = '가입된 정보가 없습니다'
        this.modalToggleChange()
        this.modalCase = 2
      } else if (code == 0 && this.authType === 2) {
        // 재설치로 인한 본인인증
        this.message = '본인인증 완료되었습니다'
        this.modalToggleChange()
        this.modalCase = 2
      } else if (code == 30099) {
        // 로그인했던 단말기 -> 다른 앱회원 정보
        //this.isInvalidInfomation()
        this.authValue = ''
        this.doubleBtnMsgType = MESSAGE_DOUBLE_BUTTON[13]; // 메시지 세팅
        this.localShowDoubleBtnDialogFlag = true;        // 다이얼로그 오픈

      } else if (code == 0) {
        this.message = '본인인증 완료되었습니다'
        this.modalToggleChange()
        this.modalCase = 1
      } else {
        this.message = '인증번호가 일치하지 않습니다<br/>다시 입력해주세요'
        this.modalToggleChange()
        this.authValue = ''
      }
    },
    modalToggleChange () {
      this.modalToggle = !this.modalToggle
    },
    modalConfirm () {
      // 비밀번호 설정하는 페이지로 넘길 객체 정보 세팅      
      if (this.modalCase === 1) {
        this.$emit('nextComponent', { componentName: 'AppSignUpPwdPage', componentData: this.shareDataSet() })
      } else if (this.modalCase === 2) {
        this.closeComponentEmit()
      }
      this.modalToggle = false
    },
    shareDataSet(){
      const shareData = {
        perNo: this.birthday + this.gender,
        ci: this.ci,
        name: this.name,
        phone: this.mobileNo,
        lastPhone: this.mobileNo.substr(this.mobileNo.length - 4, this.mobileNo.length - 1)
      }
      
      return shareData;
    },
    hideDoubleBtnDialog () {
      this.localShowDoubleBtnDialogFlag = false;
    },
    openDoubleBtnDialog () {
      this.localShowDoubleBtnDialogFlag = true;
    },

    onClickRetryOldAuth() {
      //이전 로그인 정보로 재시도
      this.localShowDoubleBtnDialogFlag = false; // 다이얼로그 닫기

      // 입력칸 다시 활성화
      this.beforeAuth = true; 

      // 인증정보 초기화
      this.name = '' // 이름
      this.birthday = '' // 생년월일
      this.gender = '' // 뒷자리
      this.mobileNo = '' // 휴대폰 번호
      this.mobileCo = '1' // 통신사
      this.authValue = '' // 인증번호

    },
    
    onClickUseNewAuth() {
      //새로운 인증정보로 로그인
      this.localShowDoubleBtnDialogFlag = false; // 다이얼로그 닫기

      //인증 세이터 셋팅
      this.$store.dispatch('saveShareData', this.shareDataSet());
      localStorage.setItem('isAuth', 'true');
      //this.$router.push({ name: 'AppOrderSelect' })


      // iPhone, iPad, iPod 중 하나라도 포함되어 있으면 iOS로 판단
      if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
        this.osCheck = true
      }
      this.isRegister = true //회원

      //약관동의로 이동
      this.currentComponent = AppSignUpAgreePage   
      //this.$router.push({ name: 'AppSignUpAgreePage' });
    },

    nextComponent (value) {
      // 비밀번호 찾기 - 다른 유저 인증 완료 - 약관 동의 완료 케이스의 경우 바로 비밀번호 입력 화면으로 이동함
      if(localStorage.getItem('isAuth')){
        this.$emit('nextComponent', { componentName: 'AppSignUpPwdPage', componentData: this.shareDataSet()})
      }else{
        this.currentComponent = value.componentName
        this.shareData = value.componentData
      }

      
    }, 
    appClose () {
      const alertMsg = MESSAGE_DOUBLE_BUTTON[12]
      this.showDoubleBtnDialog(alertMsg, () => {
        this.closeOrderApp()
        this.hideDoubleBtnDialog()
      })
    },
    closeComponentToggle () {
      this.currentComponent = null
      this.shareData = {}

      window.backBtn = () => {
        if (localStorage.getItem('joinFlag')) { // bottomMenu, allMenuPopup에서 접근하였을때
          this.appMoveMain()
        } else if (this.currentComponent == null) {
          this.closeOrderApp()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.auth-wrap {
  .invalid-text {
    margin-top: 8px;
    font-weight: 400;
    color: #f8048f;
  }
  .nationality {
    display: flex;
    label {
      position: relative;
      display: flex;
      flex: 1;
      &:first-child[type="radio"] + span {
        border-right: transparent;
      }
    }
    input[type="radio"] {
      & + span {
        display: flex;
        align-items: center;
        justify-content: center;
        word-break: keep-all;
        width: 100%;
        height: 44px;
        background-color: #fff;
        font-size: 16px;
        color: #0d0d0d80;
        border: 1px solid #ddd;
        font-weight: normal;
        text-align: center;
      }
      &:checked + span {
        background-color: var(--primary);
        color: #fff;
        font-weight: bold;
        border: none;
      }
    }
  }
}
</style>
